import { SiteLayout, PageBanner } from "../components/site/SiteLayout";
import { About } from "../components/site/Sections";
import { Milestones, HQShowcase } from "../components/site/Sections2";
import { usePrefs } from "../context/PrefsContext";

export default function TentangKami() {
  const { t } = usePrefs();
  return (
    <SiteLayout>
      {(content) => (
        <div data-testid="tentang-page">
          <PageBanner title={t.nav.about} subtitle={t.banner.aboutSub} image={content.page_banners?.about?.image} video={content.page_banners?.about?.video} posY={content.page_banners?.about?.pos_y} />
          <About about={content.about} image={content.images?.about} />
          <HQShowcase />
          <Milestones milestones={content.milestones} />
        </div>
      )}
    </SiteLayout>
  );
}
